.trigger {
  display: inline-block;
}

.container {
  position: fixed;
  z-index: 10000;
  max-width: 400px;
  width: max-content;
  pointer-events: all !important;
  
  /* Match Figma design specs */
  background-color: var(--static-background-strong);
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid var(--static-divider-standard);
  color: inherit;
  /* Shadow specs from the design */
  box-shadow: 0px 3px 14px 0px rgba(0, 0, 0, 0.12);
}

/* Link styling */
.container a {
  color: #0366d6;
  text-decoration: none;
  cursor: pointer;
  position: relative;
  z-index: 2;
}

.container a:hover {
  text-decoration: underline;
}

/* Arrow styles for different placements */
.container::before {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  background-color: var(--static-background-strong);
  transform: rotate(45deg);
  border: 1px solid var(--static-divider-standard);
  z-index: 0;
}

/* Top placement (arrow at bottom) */
.top::before {
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  border-top: none;
  border-left: none;
}

/* Bottom placement (arrow at top) */
.bottom::before {
  top: -6px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  border-bottom: none;
  border-right: none;
}

/* Left placement (arrow at right) */
.left::before {
  right: -6px;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
  border-left: none;
  border-bottom: none;
}

/* Right placement (arrow at left) */
.right::before {
  left: -6px;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
  border-top: none;
  border-right: none;
}

/* TopLeft placement (arrow at bottom) */
.topLeft::before {
  bottom: -6px;
  left: 16px;
  transform: rotate(45deg);
  border-top: none;
  border-left: none;
}

/* BottomLeft placement (arrow at top) */
.bottomLeft::before {
  top: -6px;
  left: 16px;
  transform: rotate(45deg);
  border-bottom: none;
  border-right: none;
}

/* BottomRight placement (arrow at top) */
.bottomRight::before {
  top: -6px;
  right: 16px;
  transform: rotate(45deg);
  border-bottom: none;
  border-right: none;
}

.content {
  position: relative;
  z-index: 1;
}